import { format, parse } from 'date-fns';

export function formatDateStr(dateStr: string): string {
  const d = parse(dateStr, 'yyyy-MM-dd', new Date());
  return isNaN(d.getTime()) ? dateStr : format(d, 'dd MMM yyyy');
}

export function parseDateStr(dateStr: string): Date | undefined {
  const d = parse(dateStr, 'yyyy-MM-dd', new Date());
  return isNaN(d.getTime()) ? undefined : d;
}

export function formatToISO(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}
